import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {} from '@HomaHealth/ui-component-library';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import {
  Eye,
  EyeOffOutline,
  Typography,
  TextField,
} from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { Button } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import React, { useState } from 'react';
import HOMA from '../../../../public/Images/Homa.png';
// import GOOGLE from '../../../../public/Images/Google.png';
import componentConstants from '../../../core-utils/messages/componentConstants';
import InfoBar from '../../atoms/InfoBar';
import { useLocation } from 'react-router-dom';

export interface LoginOrganismProps {
  email: string;
  password: string;
  handleLoginTextChange: (
     
    e: any,
     
    name: string,
  ) => void;
  emailError: boolean;
  emailErrorMessage: string;
  passwordError: boolean;
  passwordErrorMessage: string;
  handleLoginOnclick: () => void;
  // handleGoogleLogin: () => void;
  isButtonDisabled?: boolean;
  invalidCredentialsMessage: string;
  setIsForgotPassword: React.Dispatch<React.SetStateAction<boolean>>;
}

const LoginOrganism: React.FC<LoginOrganismProps> = ({
  email,
  password,
  handleLoginTextChange,
  emailError,
  emailErrorMessage,
  passwordError,
  passwordErrorMessage,
  handleLoginOnclick,
  // handleGoogleLogin,
  isButtonDisabled,
  invalidCredentialsMessage,
  setIsForgotPassword,
}) => {
  const useStyles = makeStyles()({
    root: {
      display: 'flex',
      flexDirection: 'column',
    },
  });

  const iconArgs = {
    height: '24px',
    width: '24px',
    style: {
      cursor: 'pointer',
    },
  };

  interface LocationProps {
    state?: {
      isCreatePassword?: boolean;
    };
  }

  const { classes } = useStyles();
  const messages = componentConstants.ORGANISMS.LOGIN_ORAGNISM;
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const location: LocationProps = useLocation();

  const toggleShowPassword = () => setShowPassword(!showPassword);

  return (
    <Grid container className={classes.root}>
      <Grid style={{ marginBottom: '20px' }}>
        <img src={HOMA} alt="HOMA" />
      </Grid>
      {invalidCredentialsMessage ? (
        <InfoBar info={invalidCredentialsMessage} type="Error" />
      ) : (
        // checking whether isCreatePassword variable exists or not
        (location?.state?.isCreatePassword === true ||
          location?.state?.isCreatePassword === false) && (
          <InfoBar
            info={
              location?.state?.isCreatePassword
                ? messages.PASSWORD_CREATED_SUCCESSFULLY
                : messages.PASSWORD_RESET_SUCCESSFULLY
            }
            type="Info"
          />
        )
      )}
      <Grid style={{ marginBottom: '35px' }}>
        <Typography
          textColor={patientAccessTheme.palette.text.highemphasis}
          fontSize="24px"
          lineHeight="29.05px"
          fontType="semiBold"
          margin="0px 0px 8px 0px"
        >
          {messages.TITLE}
        </Typography>
        <Typography
          textColor={patientAccessTheme.palette.text.mediumemphasis}
          fontSize="14px"
          lineHeight="24.78px"
          fontType="regular"
        >
          {messages.SUB_TITLE}
        </Typography>
      </Grid>
      <Grid style={{ marginBottom: '17px' }}>
        <TextField
          width="372px"
          height="46px"
          placeholder={messages.EMAIL}
          onChange={(e: any) => handleLoginTextChange(e, 'email')}
          value={email}
          error={emailError}
          helperText={emailErrorMessage}
        />
      </Grid>
      <Grid style={{ marginBottom: '16px' }}>
        <TextField
          width="372px"
          height="46px"
          placeholder={messages.PASSWORD}
          type={showPassword ? 'text' : 'password'}
          endAdornment={
            showPassword ? (
              <EyeOffOutline {...iconArgs} onClick={toggleShowPassword} />
            ) : (
              <Eye {...iconArgs} onClick={toggleShowPassword} />
            )
          }
          onChange={(e: any) => handleLoginTextChange(e, 'password')}
          value={password}
          error={passwordError}
          helperText={passwordErrorMessage}
        />
      </Grid>
      <Grid
        style={{ marginBottom: '48px', cursor: 'pointer' }}
        onClick={() => setIsForgotPassword(true)}
      >
        <Typography
          textColor={patientAccessTheme.palette.primary.main}
          fontSize="12px"
          lineHeight="18px"
          fontType="medium"
        >
          {messages.FORGOT_PASSWORD}
        </Typography>
      </Grid>
      <Grid>
        <Button
          label={
            <Typography
              textColor={patientAccessTheme.palette.status.white}
              fontSize="16px"
              lineHeight="24px"
              fontType="semiBold"
            >
              {messages.BUTTON}
            </Typography>
          }
          variant="contained"
          width="372px"
          height="44px"
          color="primary"
          borderRadius="4px"
          onClick={handleLoginOnclick}
          disabled={isButtonDisabled}
        />
      </Grid>
      {/* <Grid item style={{ textAlign: 'center' }}>
        <Typography
          textColor={patientAccessTheme.palette.text.lowemphasis}
          fontSize="16px"
          lineHeight="24px"
          fontType="semiBold"
          margin="15px 0"
        >
          Or
        </Typography>
      </Grid> */}
      {/* <Grid
        item
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
        }}
      >
        <Button
          label={
            <Typography
              textColor={patientAccessTheme.palette.text.highemphasis}
              fontSize="16px"
              lineHeight="24px"
              fontType="semiBold"
            >
              {messages.GOOGLE_BUTTON}
            </Typography>
          }
          variant="outlined"
          startIcon={<img src={GOOGLE} alt="Google" />}
          width="231px"
          height="44px"
          color="default"
          borderRadius="4px"
          onClick={handleGoogleLogin}
          disabled={false}
        />
      </Grid> */}
    </Grid>
  );
};

export default LoginOrganism;
